import aiApi from "../../axiosAiConfig";
import { store } from "../../store/store";

const getAccessToken = () =>
  store.getState()?.auth?.accessToken ||
  localStorage.getItem("accessToken") ||
  "";

const withToken = (payload = {}) => ({
  token: getAccessToken(),
  ...payload,
});

export const checkAiAuth = async () => {
  const response = await aiApi.post("/api/auth/check", withToken());
  return response.data;
};

export const getAiSessionState = async () => {
  const response = await aiApi.post("/api/session/state", withToken());
  return response.data;
};

export const startAiChat = async ({ intent = "fresh", topics = [] } = {}) => {
  const response = await aiApi.post(
    "/api/chat/start",
    withToken({ intent, topics })
  );
  return response.data;
};

export const resumeAiChat = async ({ chatId }) => {
  const response = await aiApi.post(
    "/api/chat/resume",
    withToken({ chat_id: chatId })
  );
  return response.data;
};

export const sendAiChatMessage = async ({ chatId, message }) => {
  const response = await aiApi.post(
    "/api/chat/message",
    withToken({ chat_id: chatId, message })
  );
  return response.data;
};

export const transcribeAiAudio = async ({ audio, audioData, format }) => {
  const response = await aiApi.post("/api/chat/transcribe", {
    audio,
    audio_data: audioData,
    format,
  });
  return response.data;
};

export const continueAiChat = async ({ chatId }) => {
  const response = await aiApi.post(
    "/api/chat/continue",
    withToken({ chat_id: chatId })
  );
  return response.data;
};

export const endAiChat = async ({ chatId }) => {
  const response = await aiApi.post("/api/chat/end", withToken({ chat_id: chatId }));
  return response.data;
};

export const editAiUserMessage = async ({ messageId, chatId, text }) => {
  const response = await aiApi.put(
    `/api/chat/message/${messageId}`,
    withToken({ chat_id: chatId, text })
  );
  return response.data;
};

export const deleteAiUserMessage = async ({ messageId, chatId }) => {
  const response = await aiApi.delete(`/api/chat/message/${messageId}`, {
    data: withToken({ chat_id: chatId }),
  });
  return response.data;
};

export const listAiSessions = async () => {
  const response = await aiApi.get("/api/sessions", {
    params: { token: getAccessToken() },
  });
  return response.data;
};

export const getSessionMessages = async (sessionId) => {
  const response = await aiApi.get(`/api/sessions/${sessionId}`, {
    params: { token: getAccessToken() },
  });
  return response.data;
};

export const continueAiSession = async ({ sessionId }) => {
  const response = await aiApi.post(
    `/api/sessions/${sessionId}/continue`,
    withToken()
  );
  return response.data;
};

export const getAiSessionMessages = async ({ sessionId }) =>
  getSessionMessages(sessionId);
